import { useEffect, useState } from 'react';
import { prestamoService } from '../../services/api';
import '../../styles/Reportes.css';

const PrestamosSaldados = () => {
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [prestamos, setPrestamos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [mostrandoTodos, setMostrandoTodos] = useState(false);

  useEffect(() => {
    // Establecer fechas por defecto (último mes)
    const hoy = new Date();
    const haceUnMes = new Date();
    haceUnMes.setMonth(haceUnMes.getMonth() - 1);

    setFechaFin(hoy.toISOString().split('T')[0]);
    setFechaInicio(haceUnMes.toISOString().split('T')[0]);
  }, []);

  const cargarPrestamosSaldados = async () => {
    setCargando(true);
    try {
      const response = await prestamoService.getAll();
      const todos = response.data.prestamos || [];

      // Filtrar solo préstamos pagados
      let saldados = todos.filter(p => p.estado === 'pagado');

      // Si hay fechas, filtrar por rango
      if (fechaInicio && fechaFin) {
        saldados = saldados.filter(p => {
          const fechaPrestamo = new Date(p.fecha_inicio);
          return fechaPrestamo >= new Date(fechaInicio) && fechaPrestamo <= new Date(fechaFin);
        });
      }

      setPrestamos(saldados);
      setMostrandoTodos(false);
    } catch (error) {
      alert('Error al cargar préstamos saldados');
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  const cargarTodos = async () => {
    setCargando(true);
    try {
      const response = await prestamoService.getAll();
      const todos = response.data.prestamos || [];
      const saldados = todos.filter(p => p.estado === 'pagado');
      setPrestamos(saldados);
      setMostrandoTodos(true);
    } catch (error) {
      alert('Error al cargar préstamos');
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-DO');
  };

  const calcularTotales = () => {
    const totalPrestado = prestamos.reduce((sum, p) => sum + p.monto_prestado, 0);
    const totalCapital = prestamos.reduce((sum, p) => sum + p.capital, 0);
    const totalInteres = prestamos.reduce((sum, p) => sum + p.interes, 0);
    const totalGeneral = prestamos.reduce((sum, p) => sum + p.total, 0);

    return { totalPrestado, totalCapital, totalInteres, totalGeneral };
  };

  const totales = calcularTotales();

  return (
    <div className="reporte-detalle">
      <div className="reporte-header">
        <h1>✅ Préstamos Saldados</h1>
        <p>Préstamos que han sido completamente pagados</p>
      </div>

      <div className="filtros-container">
        <div className="filtro-grupo">
          <label>Fecha Inicial:</label>
          <input
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
            className="input-text"
          />
        </div>

        <div className="filtro-grupo">
          <label>Fecha Final:</label>
          <input
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
            className="input-text"
          />
        </div>

        <button onClick={cargarPrestamosSaldados} className="btn-buscar">
          Buscar
        </button>

        <button
          onClick={cargarTodos}
          className="btn-buscar"
          style={{ background: 'linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)' }}
        >
          Ver Todos
        </button>
      </div>

      {cargando && (
        <div className="loading">Cargando préstamos saldados...</div>
      )}

      {!cargando && prestamos.length > 0 && (
        <>
          <div className="info-prestamo">
            <h3>Período: {mostrandoTodos ? 'Todos los tiempos' : `${formatearFecha(fechaInicio)} - ${formatearFecha(fechaFin)}`}</h3>
            <div className="info-grid">
              <div><strong>Total Préstamos Saldados:</strong> {prestamos.length}</div>
              <div><strong>Total Prestado:</strong> ${totales.totalPrestado.toFixed(2)}</div>
              <div><strong>Total Cobrado:</strong> ${totales.totalGeneral.toFixed(2)}</div>
              <div><strong>Ganancia Total:</strong> ${totales.totalInteres.toFixed(2)}</div>
            </div>
          </div>

          <div className="tabla-container">
            <table className="tabla-reporte">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Cliente ID</th>
                  <th>Monto</th>
                  <th>Capital</th>
                  <th>Interés</th>
                  <th>Total</th>
                  <th>Tasa</th>
                  <th>Modalidad</th>
                  <th>Fecha Inicio</th>
                  <th>Cuotas</th>
                </tr>
              </thead>
              <tbody>
                {prestamos.map(prestamo => (
                  <tr key={prestamo.id}>
                    <td>{prestamo.id}</td>
                    <td>{prestamo.cliente_id}</td>
                    <td>${prestamo.monto_prestado?.toFixed(2)}</td>
                    <td>${prestamo.capital?.toFixed(2)}</td>
                    <td className="destacado">${prestamo.interes?.toFixed(2)}</td>
                    <td><strong>${prestamo.total?.toFixed(2)}</strong></td>
                    <td>{prestamo.tasa}%</td>
                    <td>{prestamo.modalidad}</td>
                    <td>{formatearFecha(prestamo.fecha_inicio)}</td>
                    <td>{prestamo.cuotas_pagadas}/{prestamo.cuotas}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="totales">
                  <td colSpan="2"><strong>TOTALES</strong></td>
                  <td><strong>${totales.totalPrestado.toFixed(2)}</strong></td>
                  <td><strong>${totales.totalCapital.toFixed(2)}</strong></td>
                  <td className="destacado"><strong>${totales.totalInteres.toFixed(2)}</strong></td>
                  <td><strong>${totales.totalGeneral.toFixed(2)}</strong></td>
                  <td colSpan="4"></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="resumen-cards">
            <div className="card-resumen">
              <div className="card-icono">✅</div>
              <div className="card-info">
                <div className="card-valor">{prestamos.length}</div>
                <div className="card-label">Préstamos Saldados</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">💰</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalPrestado.toFixed(2)}</div>
                <div className="card-label">Total Prestado</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">💵</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalGeneral.toFixed(2)}</div>
                <div className="card-label">Total Recuperado</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">📈</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalInteres.toFixed(2)}</div>
                <div className="card-label">Ganancia Total</div>
              </div>
            </div>
          </div>
        </>
      )}

      {!cargando && prestamos.length === 0 && (fechaInicio || mostrandoTodos) && (
        <div className="sin-datos">
          <p>No se encontraron préstamos saldados en el período seleccionado</p>
        </div>
      )}

      {!cargando && !fechaInicio && !mostrandoTodos && (
        <div className="sin-datos">
          <p>Selecciona un rango de fechas o haz clic en "Ver Todos"</p>
        </div>
      )}
    </div>
  );
};

export default PrestamosSaldados;
